import { makeStyles } from "tss-react/mui";
import { MiButton, MiStackedTypography } from "@miplatform/components";
import {
  ISSUE_STATUSES_KEYED,
  ORIENTATION,
  TYPOGRAPHY_VARIANTS,
} from "@miplatform/constants";
import { separateWords } from "@miplatform/utils";
import { mdiPencilOutline } from "@mdi/js";
import { Box, Divider, Typography, useTheme } from "@mui/material";
import { useMediaQuery } from "@mui/system";

function Info(props) {
  const theme = useTheme();

  const {
    text = "--",
    subtext = "--",
    subtextColor = theme.palette.common.black,
  } = props;

  return (
    <MiStackedTypography
      title={text}
      titleProps={{
        variant: TYPOGRAPHY_VARIANTS.BODY2,
        color: theme.palette.grey.medium,
      }}
      description={subtext}
      descriptionProps={{
        maxWidth: 120,
        fontWeight: theme.typography.fontWeightBold,
        color: subtextColor,
      }}
    />
  );
}

export function IssueCard({ issue = {}, index = 0 }) {
  const {
    title = "--",
    originalDescription,
    status = "--",
    areaName = "--",
    time = "--",
  } = issue;

  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));
  const { classes } = useStyles({ isSmallScreen });

  const repairStatus = separateWords(status);

  return (
    <Box className={classes.issueCard}>
      <Box className={classes.issueSection} flex={1.6}>
        <Box>
          <Typography noWrap className={classes.issueTitle}>
            {index + 1}. {title}
          </Typography>
          <Typography noWrap className={classes.issueDescription}>
            {originalDescription}
          </Typography>
        </Box>
        <Info
          text="Repair Status"
          subtext={ISSUE_STATUSES_KEYED[repairStatus].label}
          subtextColor={ISSUE_STATUSES_KEYED[repairStatus].color}
        />
      </Box>
      {!isSmallScreen && (
        <Divider orientation={ORIENTATION.VERTICAL} variant="middle" flexItem />
      )}
      <Box className={classes.issueSection} flex={1}>
        <Box className={classes.issueDetails}>
          <Info text="Area" subtext={areaName} />
          <Info text="Time" subtext={time} />
        </Box>
        <MiButton
          startIcon={{
            path: mdiPencilOutline,
            iconColor: theme.palette.grey.medium,
          }}
          sx={{ padding: 0, width: 30, height: 30, display: "none" }}
        />
      </Box>
    </Box>
  );
}

const useStyles = makeStyles()((theme, { isSmallScreen } = {}) => ({
  issueCard: {
    display: "flex",
    flexDirection: isSmallScreen ? "column" : "row",
    justifyContent: "center",
    padding: theme.spacing(3),
    gap: theme.spacing(isSmallScreen ? 2 : 8),
    backgroundColor: theme.palette.common.white,
    borderRadius: 4,
  },
  issueSection: {
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
    alignItems: "center",
  },
  issueTitle: {
    color: theme.palette.primary.main,
    fontWeight: theme.typography.fontWeightBold,
    maxWidth: 240,
  },
  issueDescription: {
    maxWidth: 240,
  },
  issueDetails: {
    display: "flex",
    justifyContent: "space-between",
    width: "55%",
    alignItems: "center",
  },
}));
